import { useMemo } from 'react';
import _map from 'lodash/map';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import SelectField from '../forms/select-field';
import { eventWeatherCancellations } from '../../utils/events';

const useStyles = makeStyles((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormWeatherCancellations = (props) => {
  const classes = useStyles();
  const { values: { eventType } } = useFormikContext();

  const options = useMemo(() => (
    _map(eventWeatherCancellations, ({ name }, value) => ({
      label: name,
      value,
    }))
  ), []);

  if (eventType === 'ONLINE_EVENT') {
    return null;
  }

  return (
    <SelectField
      name="weatherCancellation"
      label={(
        <span className={classes.label}>
          <WbSunnyIcon className={classes.icon} />
          Weather Cancellation (optional)
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormWeatherCancellations;
